(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breakwells-application-grid"] && !Shopify.designMode) return;
  try {
    

(() => {
  const query = matchMedia('(max-width:749px) and (prefers-reduced-motion:no-preference)');
  const instances = new Map();
  function mount(section) {
    if(instances.has(section)) return;
    const states = Array.from(section.querySelectorAll('.bw-app-card'), card => ({card, value:0, target:0, start:null}));
    let frame=0, previous=0, measure=true;
    function tick(time) {
      frame=0;
      if(!query.matches) {
        section.removeAttribute('data-unfold-ready');
        previous=0;
        return;
      }
      const scroll=window.scrollY, height=window.innerHeight;
      const dt=previous ? Math.min(48,time-previous) : 16;
      previous=time;
      const alpha=1-Math.exp(-dt/85);
      const reads=states.map(state => ({state,top:state.card.getBoundingClientRect().top,width:measure?state.card.clientWidth:0}));
      section.setAttribute('data-unfold-ready','');
      let busy=false;
      reads.forEach(({state,top,width},index) => {
        if(measure) state.card.style.setProperty('--unfold-media',(width/1.6)+'px');
        if(state.start===null && top<height*.88 && (index===0 || states[index-1].value>.98)) {
          state.start=scroll-Math.max(0,height*.88-top);
        }
        if(state.start!==null) {
          state.target=Math.max(state.target,Math.min(1,Math.max(0,(scroll-state.start)/(height*.38))));
        }
        const difference=state.target-state.value;
        if(Math.abs(difference)>.0005) {
          state.value+=difference*alpha;
          busy=true;
        } else state.value=state.target;
        state.card.style.setProperty('--unfold',state.value.toFixed(5));
      });
      measure=false;
      if(busy) frame=requestAnimationFrame(tick);
      else previous=0;
    }
    function schedule(){if(!frame) frame=requestAnimationFrame(tick);}
    function resize(){measure=true;schedule();}
    function focus(event){
      const state=states.find(item=>item.card.contains(event.target));
      if(state){state.target=1;state.value=1;schedule();}
    }
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',resize,{passive:true});
    query.addEventListener('change',resize);
    section.addEventListener('focusin',focus);
    instances.set(section,()=>{
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',resize);
      query.removeEventListener('change',resize);
      section.removeEventListener('focusin',focus);
    });
    schedule();
  }
  function init(root){
    if(root.matches && root.matches('.bw-applications'))mount(root);
    root.querySelectorAll('.bw-applications').forEach(mount);
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    instances.forEach((cleanup,section)=>{if(event.target.contains(section)){cleanup();instances.delete(section);}});
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breakwells-home-polish"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.bw-colour-route,.bw-system-card__route,.bw-local__card';
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const items = new Set();
  let frame = 0;
  const clamp = n => Math.max(0, Math.min(1,n));
  function topOf(element) {
    let top = 0;
    for (let node = element; node; node = node.offsetParent) top += node.offsetTop;
    return top - window.scrollY;
  }
  function render() {
    frame = 0;
    const height = window.innerHeight;
    const reads = [];
    items.forEach(element => {
      if (!element.isConnected) { items.delete(element); return; }
      const top = topOf(element);
      const stagger = element.classList.contains('bw-colour-route') && innerWidth >= 750 ? Array.from(element.parentElement.children).indexOf(element) % 2 * .08 : 0;
      reads.push({element, progress: reduced.matches ? 1 : clamp((height * (.94 - stagger) - top) / (height * .42))});
    });
    reads.forEach(({element,progress}) => {
      element.toggleAttribute('data-bw-motion', !reduced.matches);
      element.style.setProperty('--bw-scroll', progress.toFixed(4));
      const steps = element.querySelectorAll('li');
      steps.forEach((step,index) => step.toggleAttribute('data-bw-step-active', progress >= (steps.length > 1 ? index / (steps.length - 1) : 0)));
    });
  }
  function schedule(){ if (!frame) frame = requestAnimationFrame(render); }
  function init(root){
    if(root.matches && root.matches(selector)) items.add(root);
    root.querySelectorAll(selector).forEach(element => items.add(element));
    schedule();
  }
  init(document);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('load',schedule,{once:true});
  reduced.addEventListener('change',schedule);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    items.forEach(element => { if(event.target.contains(element)) items.delete(element); });
    schedule();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breakwells-trust-strip"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-bw-trust-section]';

  const formatValue = (value, decimals) => value.toLocaleString('en-GB', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });

  const init = (root) => {
    if (!root || root.dataset.bwCountupReady === 'true') return;
    root.dataset.bwCountupReady = 'true';

    const wrap = root.querySelector('[data-bw-proof-numbers]');
    const nodes = [...root.querySelectorAll('[data-bw-countup]')];
    if (!wrap || !nodes.length) return;

    let started = false;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setFinal = () => {
      nodes.forEach((node) => {
        node.textContent = `${node.dataset.display || node.dataset.target || '0'}${node.dataset.suffix || ''}`;
      });
    };

    const start = () => {
      if (started) return;
      started = true;

      if (reducedMotion) {
        setFinal();
        return;
      }

      const duration = 1450;
      const startTime = performance.now();
      nodes.forEach((node) => { node.textContent = `0${node.dataset.suffix || ''}`; });

      const tick = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        const eased = 1 - Math.pow(1 - progress, 4);

        nodes.forEach((node) => {
          const target = Number(node.dataset.target || 0);
          const rawDisplay = node.dataset.display || '';
          const decimals = rawDisplay.includes('.') ? rawDisplay.split('.')[1].length : 0;
          const current = decimals > 0
            ? Math.round(target * eased * Math.pow(10, decimals)) / Math.pow(10, decimals)
            : Math.round(target * eased);
          node.textContent = `${formatValue(current, decimals)}${node.dataset.suffix || ''}`;
        });

        if (progress < 1) requestAnimationFrame(tick);
        else setFinal();
      };

      requestAnimationFrame(tick);
    };

    const rect = wrap.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      start();
      return;
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          start();
        }
      }, { threshold: 0.12, rootMargin: '80px 0px' });
      observer.observe(wrap);
    } else {
      start();
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll(selector).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-paint-colour"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-selected-paint-colour]').forEach(function (section) {
  if (section.dataset.initialized === 'true') return;
  section.dataset.initialized = 'true';

  var params = new URLSearchParams(window.location.search);
  var selection = null;
  if (params.get('selected_paint') === '1') {
    selection = {
      name: params.get('colour_name') || '',
      code: params.get('paint_code') || '',
      finish: params.get('paint_finish') || '',
      colour: params.get('paint_swatch') || '',
      selectedAt: Date.now()
    };
    try {
      window.localStorage.setItem('breakwellsSelectedPaint', JSON.stringify(selection));
    } catch (error) {
      selection.selectedAt = Date.now();
    }
  } else {
    try {
      selection = JSON.parse(window.localStorage.getItem('breakwellsSelectedPaint') || 'null');
    } catch (error) {
      selection = null;
    }
  }

  if (!selection || (!selection.name && !selection.code)) return;

  var nameNode = section.querySelector('[data-selected-paint-name]');
  var codeNode = section.querySelector('[data-selected-paint-code]');
  var finishNode = section.querySelector('[data-selected-paint-finish]');
  var swatchNode = section.querySelector('[data-selected-paint-swatch]');
  var clearButton = section.querySelector('[data-selected-paint-clear]');

  nameNode.textContent = selection.name;
  codeNode.textContent = selection.code;
  finishNode.textContent = selection.finish
    ? selection.finish.charAt(0).toUpperCase() + selection.finish.slice(1)
    : '';
  if (selection.colour) swatchNode.style.backgroundColor = selection.colour;
  section.hidden = false;

  clearButton.addEventListener('click', function () {
    try {
      window.localStorage.removeItem('breakwellsSelectedPaint');
    } catch (error) {
      selection = null;
    }
    section.hidden = true;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-paint-lookup"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vehicle-paint-lookup').forEach(function (section) {
  if (section.dataset.routeReady === 'true') return;
  section.dataset.routeReady = 'true';

  var mode = new URLSearchParams(window.location.search).get('lookup');
  if (mode !== 'paint-code' && mode !== 'registration') return;

  function activateRoute() {
    var widget = section.querySelector('.paint-lookup-widget');
    if (!widget) return false;

    if (mode === 'paint-code') {
      var manualToggle = widget.querySelector('.paint-lookup-link');
      if (!manualToggle) return false;

      var manualPanel = widget.querySelector('.paint-lookup-manual');
      if (!manualPanel || manualPanel.hidden) manualToggle.click();

      window.requestAnimationFrame(function () {
        var manufacturer = widget.querySelector('.paint-lookup-manual select');
        if (manufacturer) manufacturer.focus();
      });
    } else {
      var registration = widget.querySelector(':scope > .paint-lookup-form input');
      if (!registration) return false;
      registration.focus();
    }

    return true;
  }

  if (activateRoute()) return;

  var observer = new MutationObserver(function () {
    if (activateRoute()) observer.disconnect();
  });

  observer.observe(section, { childList: true, subtree: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-paint-popup"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-vehicle-paint-popup]').forEach(function (dialog) {
  if (dialog.dataset.initialized === 'true') return;
  dialog.dataset.initialized = 'true';

  var delay = Number(dialog.dataset.delay) || 10000;
  var closeButton = dialog.querySelector('[data-vehicle-paint-popup-close]');

  window.setTimeout(function () {
    if (!dialog.open) dialog.showModal();
  }, delay);

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      dialog.close();
    });
  }

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });
});

  } catch(e) { console.error(e); }
})();
})();
